import React from 'react';
import SearchFormInput from './SearchFormInput';
import ClaimFormContainer from './ClaimForm';
import { Segment } from 'semantic-ui-react';

class ClaimInput extends React.Component {
  state = {
   isFormVisible: false
  }

  handleChange = (e, data) => {
    this.props.onChange(data.value);
  };

  handleInputRef = (ref) => this.inputRef = ref;

  handleClaimSubmit = (value) => {
    const claims = [...this.state.claims, {key: value.name, value: value.name, text: value.name}];
    const selected = value.name;
    this.setState({
      claims,
      searchQuery: '',
      isFormVisible: false
    });
    this.inputRef.focusSearchInput();
    this.props.onChange(selected);
  }

  getInitialModel = () => {
   if (this.state.searchQuery) {
      const search = this.state.searchQuery
      const splittedUserSearch = search.split(' ');
      const name = splittedUserSearch[0] || '';
      const surname = splittedUserSearch.slice(1).join(' ');
      return {name, surname}
    }
    return {}
  }

  handleFormShow = () => {
    this.setState({
      initialModel: this.getInitialModel(),
      isFormVisible: true
    })
  }

  handleInputChange = (e, data) => {
    this.setState({
      searchQuery: data.searchQuery
    })
  }

  render = () => (
    <SearchFormInput
      ref={this.handleInputRef}
      label="Claim"
      name="claim"
      options={this.props.options}
      value={this.props.value}
      onChange={this.handleChange}
      onAddNew={this.handleFormShow}
      fluid
      placeholder='Claim'
      onInputChange={this.handleInputChange}
      searchValue={this.state.searchQuery}
      disabled={this.state.isFormVisible}
      isFormVisible={this.state.isFormVisible}>
      {this.renderForm()}
    </SearchFormInput>
  );

  renderForm() {
    if(this.state.isFormVisible) {
      return (
        <ClaimFormContainer
          initialModel={this.state.initialModel}
          Wrapper={Segment}
          onSubmit={this.handleClaimSubmit}
          onHide={this.hideClaimForm}/>
      )
    }
  }
}

export default ClaimInput;



// WEBPACK FOOTER //
// ./src/component/ClaimInput.js